import {
  ActionType,
  FormField,
  SelectAutocompleteField,
  SelectField,
} from '../../components/AutoForm/AutoFieldNew';
import OWNERSHIP from '../../constants/Ownership';
import {BankDetailsEnum} from '../../schema-types/globalTypes';

export type bankAccountValues = {
  bankDetails?: BankDetailsEnum | '';
  providerId?: string;
  accountName?: string;
  contactId?: string | OWNERSHIP.JOINT_CODE; // note, joint is removed when saving (no contact id)
  accountNumber?: string;
  sortCode?: string;
};

export const bankDetailsField: SelectField<bankAccountValues, BankDetailsEnum> = {
  id: 'bankDetails',
  label: 'Details',
  initialValue: '',
  type: ActionType.select,
  options: [
    {label: 'Account details need validating', value: BankDetailsEnum.NEED_VALIDATING},
    {label: 'Account details not known', value: BankDetailsEnum.NOT_KNOWN},
  ],
};

export const bankProviderField: SelectAutocompleteField<bankAccountValues> = {
  id: 'providerId',
  label: 'Bank Name',
  initialValue: '',
  type: ActionType.selectAutocomplete,
  options: [],
};

export const bankContactField: SelectAutocompleteField<bankAccountValues> = {
  id: 'contactId',
  label: 'Ownership',
  initialValue: '',
  type: ActionType.selectAutocomplete,
  options: [],
};

export const bankAccountNameField: FormField = {
  id: 'accountName',
  label: 'Account Name',
  initialValue: '',
  type: ActionType.text,
};

export const bankAccountNumberField: FormField = {
  id: 'accountNumber',
  label: 'Account Number',
  labelOnTop: true,
  canBeEmpty: true,
  initialValue: '',
  type: ActionType.text,
};

export const bankAccountFields = [
  bankDetailsField,
  bankProviderField,
  bankContactField,
  bankAccountNameField,
  bankAccountNumberField,
];
